import React from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { useMoveDocument } from "@planzone/view-models";
import { DropBox } from "@common/dragAndDrop";
import { Props } from "./types";
import styles from "./styles.scss";

function Path({ path, planzone, onNavigate, className = "" }: Props) {
  const push = useNavigate();
  const { moveDocument } = useMoveDocument();

  return (
    <ul className={classNames(className, styles.path)}>
      {path.map(({ uuid, name }, index) => (
        <li
          key={uuid}
          className={classNames(styles.item, {
            [styles.planzone]: index === 0,
          })}
          onClick={() =>
            !!onNavigate
              ? onNavigate(planzone.uuid, uuid)
              : push(`/documents/folders/${uuid}`)
          }
        >
          <DropBox
            acceptedTypes={["MOVE_DOCUMENT"]}
            drop={(data) =>
              moveDocument({
                document: data.payload,
                from: data.payload.parentUuid,
                to: uuid,
              })
            }
          >
            {(data, canDrop) => (
              <p className={classNames({ [styles.dropZone]: canDrop })}>
                {index === 0 ? planzone.name : name}
              </p>
            )}
          </DropBox>
        </li>
      ))}
    </ul>
  );
}

export { Path };
